// extracted by mini-css-extract-plugin
export default {"buttonContainer":"button_buttonContainer__-90Gw","googleSignIn":"button_googleSignIn__tD4+M","inverted":"button_inverted__NLWOd"};